import React from 'react';
import styled from 'styled-components';

export default function ProfileTable({ profile, width, marginTop, textData }) {
	return (
		<Table width={width} marginTop={marginTop}>
			<TableBody>
				<TableRow>
					<TableCell>
						{textData && textData.story.Breed}: {profile.type}
					</TableCell>
					<TableCell>
						{textData && textData.story.Occupation}: {profile.job}
					</TableCell>
				</TableRow>
				<TableRow>
					<TableCell>
						{textData && textData.story.Style}: {profile.style}
					</TableCell>
					<TableCell>
						{textData && textData.story.Characteristics}:{' '}
						{profile.pesonality}
					</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	);
}

const Table = styled.div`
	display: table;
	width: 100%;
	border: 1px solid var(--third-border-color);
	border-radius: 10px;
	margin-top: ${props => props.marginTop};
`;

const TableBody = styled.div`
	display: table-row-group;
`;

const TableRow = styled.div`
	display: table-row;
`;

const TableCell = styled.div`
	display: table-cell;
	padding: 15px;
	font-family: 'NotoSansLt';
	font-weight: 300;
	font-size: 14px;

	& + & {
		border-left: 1px solid var(--third-border-color);
	}

	div${TableRow}:first-child & {
		border-bottom: 1px solid var(--third-border-color);
	}

	@media screen and (max-width: 1240px) {
		padding: 1.4rem 0.8rem;
		font-size: 1.2rem;
	}
`;
